import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageHeader } from 'antd';

import { CouponsList } from '@containers/coupons';
import CouponsActions from '@redux/CouponsRedux';
import './Coupons.less';

function CouponsPage(props) {
  const { fetchCoupons } = props;
  useEffect(() => {
    fetchCoupons();
  }, []);

  return (
    <div className="coupons main-page">
      <PageHeader
        title="Coupons"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
      />
      <CouponsList />
    </div>
  );
}

CouponsPage.propTypes = {
  fetchCoupons: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  fetchCoupons: () => dispatch(CouponsActions.fetchCoupons())
});

export default connect(
  null,
  mapDispatchToProps
)(CouponsPage);
